import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { UserInterface } from "../../user.interface";
import { USER_CONSTANT } from "../constant/user.constant";

@Injectable({
  providedIn: "root",
})
export class UserService {
  requestOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "my-auth-token",
    }),
  };

  constructor(private httpClient: HttpClient) {}

  public getUserData() {
    return this.httpClient.get(USER_CONSTANT.USER_DATA);
  }

  public getUserByRole() {
    return this.httpClient.get(USER_CONSTANT.USER_BY_ROLE);
  }

  public getUserByOfficeAdmin(officeId) {
    return this.httpClient.get(`${USER_CONSTANT.USER_BY_OFFICE}/${officeId}`);
  }

  public createUserData(userData: UserInterface) {
    return this.httpClient.post(USER_CONSTANT.USER_DATA, userData);
  }

  public getUserEdit(userId: any) {
    return this.httpClient.get(`${USER_CONSTANT.USER_DATA}/${userId}`);
  }

  public getUserInfo(userId: any) {
    return this.httpClient.get(`${USER_CONSTANT.GET_USER_INFO}/${userId}`);
  }

  public updateUser(userData: any) {
    let userId = userData.id;
    return this.httpClient.put(
      `${USER_CONSTANT.USER_DATA}/${userId}`,
      userData
    );
  }

  public assignAsAdmin(userData: UserInterface) {
    let userId = userData.id;
    return this.httpClient.put(
      `${USER_CONSTANT.ASSIGN_AS_ADMIN}/${userId}`,
      userData
    );
  }

  public deleteUserData(userId: any) {
    return this.httpClient.delete(`${USER_CONSTANT.USER_DATA}/${userId}`);
  }

  public changePaasword(passwordData: any) {
    let userId = passwordData.id;
    return this.httpClient.put(
      `${USER_CONSTANT.USER_DATA}/${userId}`,
      passwordData
    );
  }

  public saveChangedLanguage(id: number): any {
    return this.httpClient.put(
      `${USER_CONSTANT.ACTIVATE_SUPPORTED_LANG}/${id}`,
      {}
    );
  }

  public getSupportedLang() {
    return this.httpClient.get(`${USER_CONSTANT.USER_SUPPORTED_LANG}`);
  }
}
